import api from "src/features/auth/axiosConfig";

export const getConfigurations = async (showDeleted: boolean) => {
  const res = await api.get(`/app/v1/configuration?is_deleted=${showDeleted}`);
  return res.data.result;
};

export const addConfiguration = async (data: { conname: string; convalue: number }) => {
  return api.post(`/app/v1/configuration`, data);
};

export const updateConfiguration = async (id: string, data: { conname: string; convalue: number }) => {
  return api.put(`/app/v1/configuration/${id}`, data);
};

export const deleteConfiguration = async (id: string) => {
  return api.delete(`/app/v1/configuration/${id}`);
};

